import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Container,
  Button,
  Switch,
  Chip,
  ToggleButtonGroup,
  ToggleButton,
} from "@common-ui/ui";
import { Edit, ViewList, TableRows } from "@mui/icons-material";
import LoadingButton from "@mui/lab/LoadingButton";
import { DataGridPro, LicenseInfo, GridToolbar } from "@mui/x-data-grid-pro";
import { updateUserProfile } from "../../services";
import { organizationSlice } from "../../reducers/organizationReducer";

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE);

export const ToggleViews = (props) => {
  let router = useHistory();
  return (
    <ToggleButtonGroup
      value={"table-view"}
      exclusive
      onChange={props.handleView}
      aria-label="text views"
      size="small"
    >
      <ToggleButton
        onClick={() => router.push(`/orgs/tree-view/overview`)}
        value="list-view"
        aria-label="list view"
      >
        <ViewList />
      </ToggleButton>
      <ToggleButton value="table-view" aria-label="table view">
        <TableRows />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export const UserOrgsTable = ({ unfilteredData, rowSize }) => {
  let router = useHistory();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(true);
  const [updatingOrg, setUpdatingOrg] = useState("");
  const [displayLoader, setDisplayLoader] = useState(false);
  const [pageSize, setPageSize] = useState(rowSize);

  const defaultOrg = useSelector(
    (state) => state.organization?.defaultOrganization?.id
  );
  let organizations = useSelector((state) => state.organization.organizations);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const renderOrg = (org) => {
    return org?.screen_name && String(org?.screen_name).trim() !== ""
      ? org?.screen_name
      : org?.name;
  };

  const renderSwitch = (org) => {
    return (
      <Box sx={{ alignItems: "center" }}>
        <Switch
          {...{ inputProps: { "aria-label": "Switch default" } }}
          inputProps={{ "aria-label": "controlled" }}
          sx={{ mt: 1 }}
          onChange={(e) => handleChange(e, org.id)}
          name="default_switch"
          disabled={unfilteredData.length === 1}
          checked={defaultOrg === org.id}
        />
        {displayLoader && org.id === updatingOrg ? (
          <LoadingButton size="small" loading={displayLoader}></LoadingButton>
        ) : (
          ""
        )}
      </Box>
    );
  };

  const handleChange = async (e, id) => {
    setDisplayLoader(true);
    setUpdatingOrg(id);
    await updateUserProfile({ default_org: id });
    dispatch(
      organizationSlice.actions.setDefaultOrganization(
        organizations.find((org) => org.id === id)
      )
    );
    setDisplayLoader(false);
  };

  const columns = [
    {
      field: "default_org",
      headerName: "",
      renderCell: (params) => {
        if (params.id === defaultOrg) {
          return <Chip color="primary" label="Default" />;
        }
      },
    },
    {
      field: "screen_name",
      headerName: "Display name",
      width: 150,
      renderCell: (params) => {
        return renderOrg(params.row);
      },
    },
    {
      field: "parent",
      headerName: "Parent",
      width: 150,
      renderCell: (params) => {
        if (!params.row.parent) return "---";
        return renderOrg(
          unfilteredData?.find((data) => data.id === params.row.parent)
        );
      },
    },
    {
      field: "street_address",
      headerName: "Country",
      width: 150,
      renderCell: (params) => {
        return params?.row.street_address?.country_or_region;
      },
    },
    {
      field: "switch",
      headerName: "Switch Default",
      width: 150,
      align: "center",
      renderCell: (params) => {
        return renderSwitch(params);
      },
    },
    {
      field: "id",
      headerName: "Actions",
      renderCell: (params) => (
        <Box>
          <Button
            size="small"
            startIcon={<Edit size="small" />}
            sx={{ fontWeight: 200 }}
            onClick={() =>
              router.push({
                pathname: `/orgs/${params.id}/edit`,
              })
            }
          >
            Edit
          </Button>
        </Box>
      ),
    },
  ];
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          // bgcolor: "background.paper",
        }}
      >
        <Container
          // maxWidth="md"
          component="main"
          sx={{ my: 2 }}
          // style={{ height: 520 }}
        >
          <DataGridPro
            loading={isLoading}
            rows={unfilteredData}
            columns={columns}
            pagination
            components={{ Toolbar: GridToolbar }}
            disableSelectionOnClick
            autoHeight={true}
            pageSize={pageSize}
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            density="comfortable"
            sx={{
              border: 0,
              ".MuiDataGrid-columnSeparator": {
                display: "none",
              },
              "&.MuiDataGrid-root": {
                border: "none",
              },
              "& .MuiDataGrid-cell:focus-within": {
                outline: "none !important",
              },
              ".MuiDataGrid-columnHeaders": {
                backgroundColor: "#F8F8F8",
                border: "1px solid #EBEBEB",
                minHeight: "40px !important",
                maxHeight: "40px !important",
                lineHeight: "40px !important",
              },
              ".MuiDataGrid-virtualScroller": {
                marginTop: "40px",
              },
            }}
          />
        </Container>
      </Box>
    </>
  );
};

UserOrgsTable.defaultProps = {
  rowSize: 25
}
